module.exports = __webpack_public_path__ + "img/icon-user-blue.1ac401db.svg";